import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  ControlContainer,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { ServiceDataFields } from '@app/modules/service-data/components/service-data/service-data-form/field-sets/service-data-fields.enum';
import {
  PregnancyType,
  PriorScreeningTestType,
} from '@app/modules/service-data/types/service-data.types';
import { TranslateModule } from '@ngx-translate/core';
import { SelectOptionComponent } from '@shared/components/select/select-option/select-option.component';
import { SelectComponent } from '@shared/components/select/select.component';
import { ValidationErrorComponent } from '@shared/components/validation-error/validation-error.component';
import { InputValidationStatusDirective } from '@shared/directives/input-validation-status.directive';
import { controlContainerProvider } from '@shared/helpers';
import { combineLatest, startWith } from 'rxjs';

@Component({
  selector: 'app-service-data-form-prior-screening-test',
  imports: [
    ValidationErrorComponent,
    ReactiveFormsModule,
    TranslateModule,
    InputValidationStatusDirective,
    SelectComponent,
    SelectOptionComponent,
  ],
  templateUrl: './service-data-form-prior-screening-test.component.html',
  viewProviders: [controlContainerProvider],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceDataFormPriorScreeningTestComponent implements OnInit {
  private controlContainer = inject(ControlContainer);

  @Input({ required: true }) fieldSet: string[];
  protected get form() {
    return this.controlContainer.control as FormGroup;
  }

  protected readonly Object = Object;
  protected readonly PriorScreeningTestType = PriorScreeningTestType;

  private destroyRef = inject(DestroyRef);

  ngOnInit() {
    const priorScreeningTypeControl = this.form.get(
      'priorScreeningTest.priorScreeningTestType'
    );
    const pregnancyTypeControl = (this.form.root as FormGroup).get(
      'serviceInformation.shared.currentPregnancyInformation.pregnancyType'
    );

    combineLatest([
      priorScreeningTypeControl.valueChanges.pipe(
        startWith(priorScreeningTypeControl.value)
      ),
      pregnancyTypeControl.valueChanges.pipe(
        startWith(pregnancyTypeControl.value)
      ),
    ])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(([priorScreeningTestType, pregnancyType]) => {
        if (priorScreeningTestType === PriorScreeningTestType.NoTestTaken) {
          this.form.get('priorScreeningTest.firstTRisks').reset(null);
          this.form.get('priorScreeningTest.firstTRisks').disable();
          this.form.get('priorScreeningTest.secondTRisks').reset(null);
          this.form.get('priorScreeningTest.secondTRisks').disable();
        } else {
          this.form.get('priorScreeningTest.firstTRisks').enable();
          if (pregnancyType === PregnancyType.twins) {
            this.form.get('priorScreeningTest.secondTRisks').enable();
          } else {
            this.form.get('priorScreeningTest.secondTRisks').disable();
            this.form.get('priorScreeningTest.secondTRisks').reset(null);
          }
        }
      });
  }

  protected readonly ServiceDataFields = ServiceDataFields;
}
